export { default as StrategyDeleteModal } from './StrategyDeleteModal';
